import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Marquee from "@/components/site/Marquee";
import WaitlistModal from "@/components/site/WaitlistModal";
import Hero from "@/components/site/sections/Hero";
import Story from "@/components/site/sections/Story";
import Destination from "@/components/site/sections/Destination";
import Offer from "@/components/site/sections/Offer";
import Booking from "@/components/site/sections/Booking";
import FooterLegal from "@/components/site/sections/FooterLegal";
import { useLang } from "@/context/LanguageContext";

const FALLBACK = {
  phase: "waitlist",
  prix_affiche: "≈ 1 490 € (provisoire)",
  prix_note: "",
  booking_url: "",
  places_total: 76,
  places_restantes: 76,
  places_prises: 0,
};

export default function Landing() {
  const { t } = useLang();
  const [config, setConfig] = useState(FALLBACK);
  const [modalOpen, setModalOpen] = useState(false);

  const loadConfig = () => {
    api
      .get("/site-config")
      .then(({ data }) => setConfig(data))
      .catch(() => setConfig(FALLBACK));
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const openModal = () => setModalOpen(true);

  return (
    <SmoothScroll>
      <div className="noise-overlay" />
      <Header onCta={openModal} phase={config.phase} />

      <main>
        <Hero onCta={openModal} />
        <Marquee items={t.marquee} />
        <Story />
        <Destination />
        <Offer />
        <Booking config={config} onCta={openModal} />
        <FooterLegal />
      </main>

      <WaitlistModal open={modalOpen} onOpenChange={setModalOpen} onSuccess={() => loadConfig()} />
    </SmoothScroll>
  );
}
